import { httpClient } from "./httpClient";
import { getToken, getUserName } from "../Common/utils/auth";
import { BASE_URL } from "../Common/constant";
import axios from "axios";

export const updatePricing = async (pricing: any) => {
    try {
        const result = await axios.post(BASE_URL + "pricing/update", { data: pricing },
            {
                headers: {
                    encryption: false,
                    token: getToken()
                },
            });
        return result.data;
    } catch (error) {
        console.error("Error updating pricing:", error);
        throw error;
    }
};

export const getPricing = async () => {
    try {
        const result = await axios.get(BASE_URL + "pricing/get",
            {
                headers: {
                    encryption: false,
                    token: getToken()
                },
            });
        return result.data.data[0];
    } catch (error) {
        console.error("Error fetching pricing:", error);
        throw error;
    }
};

export const updateConnection = async (connectionData: any) => {
    try {
        const result = await axios.post(BASE_URL + "agent/connection/update", connectionData,
            {
                headers: {
                    encryption: false,
                    token: getToken()
                },
            });
        return result.data;
    } catch (error) {
        console.error("Error updating connection:", error);
        throw error;
    }
};

export const findConnectionByAgent = async (agentName: string) => {
    try {
        const result = await axios.post(BASE_URL + "agent/connection/get", {
            "agent": agentName
        },
            {
                headers: {
                    encryption: false,
                    token: getToken()
                },
            });
        return result.data.data;
    } catch (error) {
        console.error("Error finding connection by agent:", error);
        throw error;
    }
};

export const getAllAgents = async () => {
    try {
        const result = await axios.get(BASE_URL + "agent/getall/active", {
            headers: {
                encryption: false,
                token: getToken()
            },
        });
        return result.data.data.agents;
    } catch (error) {
        console.error("Error fetching all agents:", error);
        throw error;
    }
};

export const fetchSalesHistory = async (agentName: string) => {
    try {
        const result = await axios.post(BASE_URL + "agent/slaes/getall", { "agent": agentName },
            {
                headers: {
                    encryption: false,
                    token: getToken()
                },
            });
        return result.data.data;
    } catch (error) {
        console.error("Error fetching sales history:", error);
        throw error;
    }
};

export const sendSmsToAgent = async (smsData: any) => {
    try {
        const result = await axios.post(BASE_URL + "agent/sendsms", { sms: smsData },
            {
                headers: {
                    encryption: false,
                    token: getToken()
                },
            });
        return result.data;
    } catch (error) {
        console.error("Error sending SMS:", error);
        throw error;
    }
};